import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'switchLanguage'
})
export class WebsiteTranslatePipe implements PipeTransform {

  transform(value: string, isTranslationEnabled: boolean, translatedValue: string): string {
    // If translation is enabled but translatedValue is missing/undefined/null/empty, 
    // fall back to original value
    if (isTranslationEnabled && translatedValue !== null && translatedValue !== undefined && translatedValue.trim() !== '') {
      return translatedValue;
    }
    return value;
  }

}


// WEBPACK FOOTER //
// ./src/app/website/translation.pipe.ts